export const MAX_RECORDING_TIME = 60; // 60 seconds

// Default video dimensions
export const DEFAULT_VIDEO_WIDTH = 1280;
export const DEFAULT_VIDEO_HEIGHT = 720;

// Mobile video dimensions
export const MOBILE_VIDEO_WIDTH = 1102;
export const MOBILE_VIDEO_HEIGHT = 620;

export const DEFAULT_VIDEO_CONSTRAINTS: MediaTrackConstraints = {
	width: { ideal: DEFAULT_VIDEO_WIDTH, max: 1920 },
	height: { ideal: DEFAULT_VIDEO_HEIGHT, max: 1080 },
	facingMode: 'user',
	aspectRatio: { ideal: 16 / 9 },
};

export const MOBILE_VIDEO_CONSTRAINTS: MediaTrackConstraints = {
	width: { ideal: MOBILE_VIDEO_WIDTH, max: DEFAULT_VIDEO_WIDTH },
	height: { ideal: MOBILE_VIDEO_HEIGHT, max: DEFAULT_VIDEO_HEIGHT },
	facingMode: 'user',
	aspectRatio: { ideal: 4 / 3 },
};

export const RECORDING_FRAME_RATE = 30;
export const MOBILE_RECORDING_FRAME_RATE = 26;

// Silence this long during recording shows the "No audio detected" nudge
export const SILENCE_NUDGE_MS = 5000;
export const WAVE_BAR_COUNT = 4;
